var modal = document.querySelector(".modal-booking");
var triggers = document.querySelectorAll(".custom-book-and-quote_cta");
var closeButton = document.querySelector(".close-button-booking");
var openModalFooter = document.querySelector("#footer_measure_quote.c-footer_measure_quote");

function toggleModal() {
    modal.classList.toggle("show-modal-booking");
    console.log('test-booking');
}

function windowOnClick(event) {
    if (event.target === modal) {
        toggleModal();
    }
}
// querySelectorAll (not querySelector) — there are now two of these buttons
// (desktop header + mobile drawer); a single querySelector only ever bound to
// whichever one appeared first in the DOM.
triggers.forEach(function(trigger) {
    trigger.addEventListener("click", toggleModal);
});
openModalFooter.addEventListener("click", toggleModal);
closeButton.addEventListener("click", toggleModal);
window.addEventListener("click", windowOnClick);


document.addEventListener("readystatechange", (event) => {
  // The page is fully loaded
  if (document.readyState === 'complete') {
    const currentPage1 = window.location.href.split("/").pop().replace(/\s/g, '-').toLowerCase();
    let setIntervalTimeApp = 0;

    const checkPopForm = setInterval(() => {
      if (setIntervalTimeApp >= 10) {
        clearInterval(checkPopForm);
        return;
      }

      const formElement = document.querySelector(".globo-form-app");
      if (formElement) {
        const selectElement = document.getElementById("9127-select-3");
        if (selectElement) {

          const options = Array.from(selectElement.options);
          let foundMatch = false;

          for (let option of options) {
            if (!option.disabled) {
              option.selected = false; // Reset selected attribute
              if (option.value.toLowerCase().replace(/\s/g, '-') === currentPage1) {
                option.selected = true;
                foundMatch = true;
                break;
              }
            }
          }

          if (!foundMatch) {
            // If no match found, select the first enabled option
            const firstEnabledOption = options.find(option => !option.disabled);
            if (firstEnabledOption) {
              firstEnabledOption.selected = true;
            }
          }

          selectElement.dispatchEvent(new Event('change'));
        }
        clearInterval(checkPopForm);
      } else {
        setIntervalTimeApp += 1;
      }
    }, 1000);
  }
});



// Opening mega menu nav on hover
document.addEventListener('DOMContentLoaded', () => {
  // .nav-dropdown--hover: same hover-open behavior for a plain dropdown item
  // (e.g. Inspiration) that deliberately isn't a .mega-menu — see the comment
  // in sections/header.liquid on why it needs its own class rather than reusing
  // .mega-menu (that class's CSS breaks a plain dropdown's width).
  document.querySelectorAll(".header__inline-menu .mega-menu, .header__inline-menu .nav-dropdown--hover").forEach(function(element){
    var closeTimer = null;

    // mouseenter/mouseleave (not mouseover/mouseout) because they don't bubble —
    // moving the cursor from the summary into .mega-menu__content (both children
    // of this same element) previously fired a bubbled mouseout and closed the
    // panel mid-move, even though the cursor never left the mega-menu's area.
    //
    // That alone isn't enough, though: .mega-menu__content's `top: 100%` resolves
    // against a positioned ancestor higher up than the summary itself, leaving a
    // real ~13px dead strip between the summary's bottom edge and the panel's own
    // top edge. Crossing that strip puts the cursor briefly over the page content
    // behind the header — not a descendant of this element — firing a genuine
    // mouseleave before the cursor reaches the panel. Debouncing the close (and
    // cancelling it on the next mouseenter, which fires again once the cursor
    // lands on the panel) rides out that brief gap instead of trying to close it
    // in CSS, which would need to track the dropdown's dynamic height per item.
    element.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
      element.setAttribute('open', 'true');
    });

    element.addEventListener('mouseleave', () => {
      closeTimer = setTimeout(() => {
        element.removeAttribute('open');
      }, 200);
    });
  });
});